<template>
    <GenericConnectedIntegrationCard
        :integration="integration"
        :providerData="providerData"
        @onIntegrationDeleted="emits('onIntegrationDeleted')"
    >
        <template #actions>
            <GoogleCalendarIntegrationSettingsButtonDrawer
                :integration="integration"
                @onSuccess="emits('onIntegrationUpdated', $event)"
            />
        </template>
    </GenericConnectedIntegrationCard>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import Integration from '@/App/Integration/Entity/Integration'
    import { type IntegrationProviderDataType } from '@/Shared/AutoGenerated/Main'
    import GoogleCalendarIntegrationSettingsButtonDrawer from '@/App/Integration/Component/GoogleCalendarIntegrationSettingsButtonDrawer.vue'
    import GenericConnectedIntegrationCard from '@/App/Integration/Component/GenericConnectedIntegrationCard.vue'

    const emits = defineEmits<{
        onIntegrationDeleted: []
        onIntegrationUpdated: [{ integration: Integration }]
    }>()

    const props = defineProps({
        integration: {
            type: Object as PropType<Integration>,
            required: true,
        },
        providerData: {
            type: Object as PropType<IntegrationProviderDataType>,
            required: true,
        },
    })
</script>
